import { Button as AntdButton } from "@empglabs/backoffice-ui-kit"

const Button = props => {
  return <AntdButton {...props} />
}

export default Button
